import { Component, OnInit } from "@angular/core";

import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";

export interface ActionArgs {
  title: string;
  actions: Array<string>;
}

@Component({
  selector: "myp-action",
  templateUrl: "action.component.html",
})
export class ActionComponent extends BaseComponent implements OnInit {
  public title: string;
  public actions: Array<string>;
  public show: boolean;

  constructor(userService: UserService, private _eventBus: EventBusService) {
    super(userService);
  }

  ngOnInit() {
    this._eventBus.observe(this._eventBus.types.showActionChooser).subscribe((result: ActionArgs) => {
      this.actions = result.actions;
      this.title = result.title;
      setTimeout(() => {
        this.show = true;
      }, 100);
    });
  }

  choose(action, e) {
    if (e) e.stopPropagation();
    this._eventBus.emit(this._eventBus.types.actionChosen, action);
    this.show = false;
    setTimeout(() => {
      this.actions = undefined;
    }, 250);
  }
}
